import React from 'react'
import tw, { css, theme } from 'twin.macro'

export default ({ node }) => {
  if (!node || !node.secure_url) {
    return null
  }

  if (node.format === 'mp4') {
    if (node.height > node.width) {
      return (
        <video
          controls
          tw="rounded"
          css={css`
            display: block;
            width: 100%;
            max-width: min(375px, 100%);
          `}
        >
          <source src={node.secure_url} type="video/mp4" />
          <p>Your browser doesn't support HTML5 video.</p>
        </video>
      )
    } else {
      return (
        <video
          controls
          tw="shadow-md rounded"
          css={css`
            display: block;
          `}
        >
          <source src={node.secure_url} type="video/mp4" />
          <p>Your browser doesn't support HTML5 video.</p>
        </video>
      )
    }
  }

  if (node.format === 'webm') {
    return (
      <video controls tw="shadow-md rounded" css={css``}>
        <source src={node.secure_url} type="video/webm" />
        <p>Your browser doesn't support HTML5 video.</p>
      </video>
    )
  }

  if (node.resource_type === 'image') {
    return (
      <figure>
        <img tw="shadow-lg rounded mx-auto" loading="lazy" src={node.secure_url} alt={node.alt} />
        <figcaption>{node.context ? node.context.custom.caption : ' '}</figcaption>
      </figure>
    )
  }

  return <div></div>
}
